/**
 * How far outside the label an element may be parked.
 *
 * The layout editor is a workbench, not only the label: composing a layout
 * means having somewhere to drop a block while rearranging the ones that stay.
 * Only the part of an element that falls inside the page is printed, so
 * parking one out here is the explicit way of saying "not on this label"
 * without deleting it — and a block straddling the edge prints exactly the
 * portion that overlaps the page.
 *
 * 40cm on every side is several label-widths of room in each direction: the
 * operator is meant to experience the grid as open space, not as a box with a
 * wall just past the edge. It is still a finite number because the document
 * contract has to be able to tell a parked block from corrupt coordinates.
 *
 * Lives in its own module because both the geometry solver and the document
 * contract (`prepackaged-label-editor.ts`) need it, and they already import
 * each other in one direction.
 */
export const LAYOUT_OVERFLOW_MARGIN_MM = 400;
